export default __webpack_public_path__ + "static/media/importance-of-education.e7b32ee5.png";